import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SyncUserSettingsService, UserService } from '@frontend/sports/user/feature';
import { Store } from '@ngrx/store';
import { Decimal } from 'decimal.js';
import { Observable, Subscription, map } from 'rxjs';

import { betslipSelector } from '../../../../base/store/selectors';
import { IBetslipRootState, IBetslipState } from '../../../../base/store/state';
import { BetslipGeneratorContextType } from '../../../bet-generation/models';
import { BetslipSummaryService } from '../../../summary/services/betslip-summary.service';
import { EditBetAddPicksContainerOffsetProvider } from '../../services/edit-bet-add-picks-container-offset.provider';
import { IEditMyBetState } from '../../state';
import { EditBetAddPicksContainerComponent } from './edit-bet-add-picks-container.component';

@Component({
    selector: 'bs-edit-bet-add-picks-container-mobile',
    templateUrl: './edit-bet-add-picks-container-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-add-picks-container-mobile.component.scss'],
    standalone: false,
})
export class EditBetAddPicksContainerMobileComponent extends EditBetAddPicksContainerComponent implements OnInit, OnDestroy {
    readonly betslipState$: Observable<IBetslipState>;
    override readonly editMyBetState$: Observable<IEditMyBetState>;
    readonly possibleWinnings$: Observable<Decimal | null>;

    @HostBinding('class') className = 'betslip betslip-vars-scope';
    @ViewChild('editBetSelectionContainer', { read: ElementRef })
    editBetSelectionContainer: ElementRef;

    @Output() picksContainerBottomOffset: EventEmitter<number> = new EventEmitter<number>();

    private addPicksStateSubscription: Subscription;

    constructor(
        private summaryService: BetslipSummaryService,
        private user: UserService,
        private userSettings: SyncUserSettingsService,
        public override siteCore: Sitecore,
        private editMyBetAddPicksContainerOffsetProvider: EditBetAddPicksContainerOffsetProvider,
        store: Store<IBetslipRootState>,
        epcotConfig: EpcotConfig,
    ) {
        super(siteCore, store, epcotConfig);
        this.betslipState$ = store.select(betslipSelector);
        this.editMyBetState$ = this.betslipState$.pipe(map((bs) => bs.types.editBet));

        this.possibleWinnings$ = this.summaryService
            .getSummary$(BetslipGeneratorContextType.EditBetSwap)
            .pipe(map(([betslip, summary]) => summary.possibleWinningsNet));
    }

    get possibleWinningsTitle(): string {
        return this.user.isAuthenticated && this.userSettings.configSettings.winningsTaxRate > 0
            ? this.siteCore.betslip.messages.PossibleWinningsNet
            : this.siteCore.betslip.messages.PossibleWinnings;
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.addPicksStateSubscription = this.editMyBetAddPicksContainerOffsetProvider
            .getBottomOffset(this.betslipState$, () => this.editBetSelectionContainer)
            .subscribe((bottomOffset) => this.picksContainerBottomOffset.emit(bottomOffset));
    }

    ngOnDestroy(): void {
        this.addPicksStateSubscription.unsubscribe();
    }
}
